<template>
  <article class="feature-page">
    <div class="max-w-4xl mx-auto px-4 py-10">
      <h2 class="text-2xl lg:text-3xl font-bold text-center mb-4">
        piceditor.io Resize Image: Adjust Size by Pixels or Percent Instantly
      </h2>
      <p class="text-xl text-center mb-6">
        Quickly resize images with precise pixel control or flexible percentages, while keeping perfect proportions.
      </p>

      <p class="mb-4">
        Whether you're optimizing for social media, print, or web performance, our Resize Image tool makes adjusting
        photo dimensions effortless. Choose to resize by exact pixel values or scale by percentage. Maintain aspect
        ratio automatically for clean, distortion-free results — or disable it for custom resizing.
      </p>

      <h3 class="text-2xl font-bold mt-12 mb-6">Why Use Resize Image?</h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 feature-page__specific">
        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/platform.png" alt="Flexible Controls" />
          <strong>Flexible Controls</strong>
          <p>
            Resize by pixels for precision or by percentage for quick scaling, with easy toggles to match your needs.
          </p>
        </div>

        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/quality.png" alt="Keep Aspect Ratio" />
          <strong>Keep Aspect Ratio</strong>
          <p>Preserve original proportions to avoid distortion, or freely adjust width and height independently.</p>
        </div>

        <div class="flex flex-col space-y-4 items-center text-center">
          <img src="@/images/landing_pages/speed.png" alt="Real-time Preview" />
          <strong>Real-time Preview</strong>
          <p>See changes instantly as you adjust dimensions, ensuring your resized images look exactly as expected.</p>
        </div>
      </div>

      <h3 class="text-2xl font-bold mt-12 mb-6">How It Works</h3>
      <ol class="list-decimal pl-5 mb-6">
        <li><strong>Upload Your Image:</strong> Drag and drop or select an image from your device.</li>
        <li>
          <strong>Choose Resize Mode:</strong> Select pixel-based resizing for exact control or percentage-based for
          scaling.
        </li>
        <li><strong>Enable Keep Ratio (optional):</strong> Maintain original proportions or customize freely.</li>
        <li>
          <strong>Preview & Download:</strong> Instantly preview changes and download the resized image when ready.
        </li>
      </ol>

      <p>
        PicEditor.io Resize Image tool works seamlessly across all devices, allowing you to adjust image sizes with
        precision and ease — anytime, anywhere.
      </p>
    </div>
  </article>
</template>
